import request from '@/utils/request'
export function fetchList(data) {
  return request({
    url: '/lockerStatus/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/lockerStatus/Get',
    method: 'post',
    data: { id: id },
  })
}

export function createItem(data) {
  console.log('createItem', data)
  return request({
    url: '/lockerStatus/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)
  return request({
    url: '/lockerStatus/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/lockerStatus/Delete',
    method: 'delete',
    data,
  })
}
